import {navigate} from 'gatsby';

const safeNavigate = (path: string): void => {
	if (typeof window !== 'undefined') {
		navigate(path);
	}
};

export default safeNavigate;
